/* Copyright (c) 2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ApplicationPDService, ServiceTableEntry } from "~/models";
import { PDEscalationPolicy, PDService } from "~/models/pagerDuty";
import { displayPDIntegrations } from "~/tools/display/displayPDIntegrations";

export function getServicesTableData(
  services: ApplicationPDService[],
  allServices: PDService[],
  allEPs: PDEscalationPolicy[]
): ServiceTableEntry[] {
  const servicesMap = Object.fromEntries(
    allServices.map((s) => [s.pagerduty_id, s])
  );
  const epsMap = Object.fromEntries(allEPs.map((ep) => [ep.pagerduty_id, ep]));

  return services.map((service) => {
    const serviceDetails = servicesMap[service.serviceId] || {};
    const epDetails = allEPs.find(
      (ep) => ep.name === serviceDetails.escalation_policy
    );

    return {
      serviceId: serviceDetails.id,
      name: serviceDetails.name,
      pagerdutyId: serviceDetails.pagerduty_id,
      integration: displayPDIntegrations(serviceDetails),
      epId: epDetails?.pagerduty_id,
      epName: serviceDetails.escalation_policy,
      softLaunchEpId: service.softLaunchEpId,
      softLaunchEpName: service.softLaunchEpId
        ? epsMap[service.softLaunchEpId]?.name
        : "-",
      targetEpId: service.targetEpId,
      targetEpName: service.targetEpId ? epsMap[service.targetEpId]?.name : "-",
    };
  });
}
